<template>
  <BaseModal
    small
    :heading="$t('wavy_onboarding.close_wavy_account.heading')"
    @close="emit('close')"
  >
    <Flex direction="column">
      <BaseText>
        {{ $t('wavy_onboarding.close_wavy_account.description', brandName()) }}
      </BaseText>
      <BaseAlert
        color="info"
        :text="$t('wavy_onboarding.close_wavy_account.alert')"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="emit('close')"
      >
        {{ $t('wavy_onboarding.close_wavy_account.button_not_yet') }}
      </BaseButton>
      <BaseButton
        color="primary"
        href="https://app.wavy.co/unsubscribe"
        v-test="'wavy-onboarding-close-account-button'"
        @click="submit"
      >
        {{ $t('wavy_onboarding.close_wavy_account.button_close_wavy_account') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { brandName } from '@/helpers/brand-name';

const emit = defineEmits(['close', 'submit']);

const submit = () => {
  const { mutate } = useMutation(gql`
    mutation updateOnboardingTask($input: UpdateOnboardingTaskInput!) {
      updateOnboardingTask(input: $input) {
        onboardingTask {
          id
        }
      }
    }
  `);

  mutate({
    input: {
      task: 'STOP_WAVY_SUBSCRIPTION',
      taskStatus: 'COMPLETE',
    },
  }).then(() => {
    emit('submit');
    emit('close');
  });
};
</script>
